import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'

/*
 * Market · Movers before its first response: the LOADED board, block for
 * block. The tabs and the sector chip are one row, 16px above the table, and
 * the pager sits 24px under it (Pagination's own `mt-6`), as in MoversScreen.
 *
 *   tabs + sector filter row   36   TabBar's row; the chip is `h-9` at lg
 *   table                      one head band over ten two-line rows
 *   pager                      32
 *
 * Every block reuses the loaded component's own box classes (`DataTableSkeleton`
 * reads DataTable's, the tab row is TabBar's 36px) so it matches at every
 * width, not just a measured one.
 *
 * Bars only, no words, so nothing here can be mistaken for the loaded
 * content. The page's own TitleRow is the exception, and ScreenLayout draws
 * it (see MoversScreen).
 */

const ROW_COUNT = 10
const TAB_LABELS = ['w-14', 'w-12', 'w-16', 'w-12', 'w-24', 'w-14']

/** The six view tabs on TabBar's 36px row, and the sector trigger beside them from `@2xl`. */
function TabRowSkeleton({ withSector }: { withSector: boolean }) {
  return (
    <div className="flex flex-col gap-4 @sm:items-start @2xl:flex-row @2xl:flex-wrap @2xl:items-center">
      <div className="flex h-9 items-center gap-5">
        {TAB_LABELS.map((w, index) => (
          <Skeleton key={index} className={cn('h-5', w)} />
        ))}
      </div>
      {withSector ? <Skeleton className="h-11 w-full @sm:w-40 @2xl:ml-auto @2xl:h-9" /> : null}
    </div>
  )
}

/**
 * `brokers` is the one view that loads differently: no sector chip, and the brokers table's
 * one-line rows (`md`, the default) rather than the stock views' two-line `lg` ones.
 */
export function MoversBoardSkeleton({ brokers = false }: { brokers?: boolean }) {
  return (
    <div className="flex flex-col gap-4">
      <TabRowSkeleton withSector={!brokers} />
      <div>
        <DataTableSkeleton rows={ROW_COUNT} columns={4} rowHeight={brokers ? 'md' : 'lg'} />
        <Skeleton className="mt-6 h-8 w-full" />
      </div>
    </div>
  )
}
